import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's127g-s127m01',
    templateUrl: './s127g-s127m01.component.html'
})
export class S127gS127m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    revnbr: any = {};
    usag1: any = {};
    usag2: any = {};
    usag3: any = {};
    usag4: any = {};
    usag5: any = {};
    usag6: any = {};
    usag7: any = {};
    usag8: any = {};
    usag9: any = {};
    usag10: any = {};
    usag11: any = {};
    usag12: any = {};
    usag13: any = {};
    usag14: any = {};
    usag15: any = {};
    msgln: any = {};
    selmen: any = {'value': '2-SEL'};
    prev: any = {'value': '7-PREV'};
    next: any = {'value': '8-NEXT'};
    pagt: any = {'value': '11-PAGT'};
    currc1: any = {'value': 'SH4-CUST INQ'};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};
    paymt: any = {'value': 'SH5-PAYMT'};
    last: any = {'value': 'SH6-LAST'};
    first: any = {'value': 'SH7-FIRST'};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'revnbr', 'usag1', 'usag2', 'usag3', 'usag4', 'usag5', 'usag6', 'usag7', 'usag8', 'usag9', 'usag10', 'usag11', 'usag12', 'usag13', 'usag14', 'usag15', 'msgln', 'selmen', 'prev', 'next', 'pagt', 'currc1', 'prevc1', 'paymt', 'last', 'first'];
    public LINES: number[] = [1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
